import { gql } from '@apollo/client'
import { VOOH_IMPRESSIONS_FILTER_FIELDS } from '../fragments'

export const GET_VOOH_IMPRESSIONS = gql`
  ${VOOH_IMPRESSIONS_FILTER_FIELDS}
  query voohImpressions(
    $campaignId: ID!
    $agglomerations: [ID!]
    $brands: [ID!]
    $cities: [ID!]
    $creations: [ID!]
    $media: [ID!]
    $network: [ID!]
  ) {
    voohImpressions(
      campaignId: $campaignId
      agglomerations: $agglomerations
      brands: $brands
      cities: $cities
      creations: $creations
      media: $media
      network: $network
    ) {
      values {
        day
        impressions
        cumulativeImpressions
      }
      facets {
        agglomerations {
          ...VoohImpressionsFacets
        }
        brands {
          ...VoohImpressionsFacets
        }
        cities {
          ...VoohImpressionsFacets
        }
        creations {
          ...VoohImpressionsFacets
        }
        media {
          ...VoohImpressionsFacets
        }
        network {
          ...VoohImpressionsFacets
        }
      }
    }
  }
`

export const GET_VOOH_IMPRESSIONS_PUBLIC = gql`
  ${VOOH_IMPRESSIONS_FILTER_FIELDS}
  query voohCampaignReportPublic(
    $voohCampaignUuid: String!
    $agglomerations: [ID!]
    $brands: [ID!]
    $cities: [ID!]
    $creations: [ID!]
    $media: [ID!]
    $network: [ID!]
  ) {
    voohCampaignReportPublic(voohCampaignUuid: $voohCampaignUuid) {
      impressions(
        agglomerations: $agglomerations
        brands: $brands
        cities: $cities
        creations: $creations
        media: $media
        network: $network
        voohCampaignUuid: $voohCampaignUuid
      ) {
        values {
          day
          impressions
          cumulativeImpressions
        }
        facets {
          agglomerations {
            ...VoohImpressionsFacets
          }
          brands {
            ...VoohImpressionsFacets
          }
          cities {
            ...VoohImpressionsFacets
          }
          creations {
            ...VoohImpressionsFacets
          }
          media {
            ...VoohImpressionsFacets
          }
          network {
            ...VoohImpressionsFacets
          }
        }
      }
    }
  }
`
